import React from 'react';
import { Route, Routes } from 'react-router';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import './App.css';
import LoginForm from 'pages/login';
import store from 'redux/store/store';
import Interface from 'pages/interface';
import PageNotFound from 'pages/no_page';
import AdminPage from 'pages/admin_page';
import CreateDomain from 'pages/create_domain';
import DisplayData from 'component/display_area';
import OuData from 'component/table_component/ou_data';
import UsersData from 'component/table_component/users_data';
import GroupsData from 'component/table_component/groupData';
import CreateGroup from 'component/create_new_group_component';
import ComputersData from 'component/table_component/computersData';
import CreateUser from 'component/create_user_component/create_singleUser';
import CreateChildOU from 'component/create_ou_component/create_childOu_components';
import CreateParentOU from 'component/create_ou_component/create_parentOu_component';
import EmailTemplate from 'pages/email_template';
import Settings from 'pages/settings_page';
import License from 'pages/license';
import ForgotPassword from 'pages/forgot_password';
import ResetPassword from 'pages/reset_password';
import SetUpPage from 'pages/setup_page';
import Themes from 'pages/themes_page';
import ChangePasswordPage from 'pages/change_password';
import EmailDelivery from 'pages/email_delivery';
import CustomizeThemes from 'component/themes_component/customize_themes';
import ThemeProvider from 'component/themes_component/theme_provider';
import Endpoints from 'pages/endpoints';
import Brandings from 'pages/brandings';
import ApiSettings from 'pages/api_settings';

function App() {
  return (
    <div className='body-content'>
      <Provider store={store}>
        <BrowserRouter>
          <Routes>
            <Route path='/' element={<ThemeProvider />}>
              <Route path='/login' element={<LoginForm />} />
              <Route path='/forgot_password' element={<ForgotPassword />} />
              <Route path='/reset_password' element={<ResetPassword />} />
              <Route path='/change_password' element={<ChangePasswordPage />} />
              <Route path='/setup' element={<SetUpPage />} />
              <Route path='/' element={<Interface />}>
                <Route path='/' element={<DisplayData />}>
                  <Route path='/' element={<UsersData />} />
                  <Route path='/computerdata' element={<ComputersData />} />
                  <Route path='/groupdata' element={<GroupsData />} />
                  <Route path='/oudata' element={<OuData />} />
                </Route>
                <Route path='/create_user' element={<CreateUser />} />
                <Route path='/create_group' element={<CreateGroup />} />
                <Route path='/create_ou' element={<CreateChildOU />} />
                <Route path='/create_parent_ou' element={<CreateParentOU />} />
                <Route path='/adminpage' element={<AdminPage />} />
                <Route path='/email_template' element={<EmailTemplate />} />
                <Route path='/settings' element={<Settings />} />
                <Route path='/themes' element={<Themes />} />
                <Route path='/endpoints' element={<Endpoints />} />
                <Route path='/license' element={<License />} />
                <Route path='/create_domain' element={<CreateDomain />} />
                <Route path='/customize_theme' element={<CustomizeThemes />} />
                <Route path='/email_delivery' element={<EmailDelivery />} />
                <Route path='/brandings' element={<Brandings />} />
                <Route path='/api_settings' element={<ApiSettings />} />
              </Route>
            </Route>
            <Route path='*' element={<PageNotFound />} />
          </Routes>
        </BrowserRouter>
      </Provider>
    </div>
  );
}

export default App;
